import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { aiActions } from '../../actions/aiActions';
import { Trash2 } from 'lucide-react';
import styles from './ChatHistoryPanel.module.css';

const ChatHistoryPanel = () => {
  const dispatch = useDispatch();
  const [selectedChat, setSelectedChat] = useState(null);
  const {
    chatHistories,
    loading,
    selectedChat: selectedChatFromRedux,
  } = useSelector(state => state.aiReducer);

  const handleSelectChatFromHistory = chat => {
    // Format obj to include a chat array att. that mimics the messages array for
    // consistency/reusability of existing messages iterating logic
    const { id, user, chat_title, created_at, system_response, user_prompt } =
      chat;
    const chatAsArr = [
      { role: 'user', content: user_prompt },
      { role: 'system', content: system_response },
    ];
    const formattedChatObj = { id, user, chat_title, created_at, chatAsArr };
    dispatch({
      type: aiActions.SET_SELECTED_CHAT_HISTORY,
      payload: formattedChatObj,
    });
  };

  const handleDeleteChatFromHistory = chat_id => {
    dispatch({ type: aiActions.DELETE_CHAT, payload: chat_id });
  };
  useEffect(() => {
    dispatch({ type: 'GET_CHAT_HISTORIES' });
  }, [dispatch]);

  useEffect(() => {
    setSelectedChat(selectedChatFromRedux?.id || null);
  }, [selectedChatFromRedux]);

  if (loading.addChat || loading.getChatHistories)
    return (
      <div className={styles.chatHistoryWrapper}>
        <div className={styles.titleWrapper}>
          <h2 className={styles.chatHistoryTitle}>Question History</h2>
        </div>
        <span
          className={`spinner-border spinner-border-sm ${styles.loadingQuestionHistory}`}
          role='status'
          aria-hidden='true'></span>
      </div>
    );

  return (
    <div className={styles.chatHistoryWrapper}>
      <div className={styles.titleWrapper}>
        <h2 className={styles.chatHistoryTitle}>Question History</h2>
      </div>

      <ul className={styles.chatHistoryList} role='list'>
        {chatHistories?.length > 0 ? (
          chatHistories
            .slice()
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map(chat => (
              <li
                className={`${styles.chatHistoryListItem} ${
                  selectedChat === chat.id ? styles.selected : ''
                }`}
                role='button'
                tabIndex={0}
                key={chat.id}
                onClick={() => {
                  handleSelectChatFromHistory(chat);
                }}
                aria-pressed={selectedChat === chat.id}>
                <span className={styles.chatTitle}>{chat?.chat_title}</span>
                <button
                  type='button'
                  onClick={e => {
                    e.stopPropagation();
                    handleDeleteChatFromHistory(chat.id);
                  }}
                  aria-label={`Delete chat titled ${chat?.chat_title}`}>
                  <Trash2 size={18} color='white' />
                </button>
              </li>
            ))
        ) : (
          <p className={styles.noHistoryPlaceHolder}>No question history yet</p>
        )}
      </ul>
    </div>
  );
};

export default ChatHistoryPanel;
